<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="products"
      :fixed-header="false"
      :search-options="{
        enabled: true,
        placeholder: 'Otsi tooteid',
      }"
      :pagination-options="{
        enabled: true,
        position: 'top',
        perPage: 25,
        perPageDropdown: [50, 100],
        dropdownAllowAll: true,
        nextLabel: 'Järgmised',
        prevLabel: 'Eelmised',
        rowsPerPageLabel: 'Tooteid leheküljel',
        ofLabel: '/',
        allLabel: 'Kõik',
      }"
      :sort-options="{
        enabled: true,
        initialSortBy: { field: 'timestamp', type: 'desc' },
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- <span v-if="props.column.field == 'image_url'">
          <a :href="props.row.image_url" target="_blank">Pilt</a>
        </span> -->
        <span v-if="props.column.field == 'shortcode'">
          <a
            :href="`https://instagram.com/p/${props.row.shortcode}`"
            target="_blank"
            >Postitus</a
          >
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <div slot="emptystate">
        <p v-if="products.length !== 0">Ei leidnud ühtegi toodet.</p>
        <div v-else id="loadingwrapper">
          <span id="loadingicon">🥦</span>
        </div>
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  name: "Table",
  components: {
    VueGoodTable,
  },
  props: {
    products: {
      default: [],
    },
  },
  data() {
    return {
      columns: [
        {
          label: "Kuupäev",
          field: "timestamp",
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "yyyy-MM-dd HH:mm:ss",
          width: "9rem",
          firstSortType: "desc",
        },
        {
          label: "Toode",
          field: "name",
          width: "10rem",
        },
        {
          label: "Tootja",
          field: "brand",
          width: "7rem",
        },
        {
          label: "Hind",
          field: "price",
          type: "number",
          tooltip: "Hind on ligikaudne ja võib erineda",
          formatFn: this.moneyFormat,
          firstSortType: "desc",
        },
        {
          label: "Kirjeldus",
          field: "description",
          thClass: "descriptionth",
        },
        {
          label: "Asukoht",
          field: "location",
          width: "13rem",
        },
        // {
        //   label: "V🌱",
        //   field: "vegan",
        //   tooltip: "Gluteenivaba",
        //   formatFn: this.boolFormat,
        //   globalSearchDisabled: true,
        //   width: "3rem",
        // },
        {
          label: "GV",
          field: "gluten_free",
          tooltip: "Gluteenivaba",
          formatFn: this.boolFormat,
          globalSearchDisabled: true,
          width: "1.5rem",
          firstSortType: "desc",
        },
        {
          label: "SV",
          field: "sugar_free",
          tooltip: "Suhkruvaba",
          formatFn: this.boolFormat,
          globalSearchDisabled: true,
          width: "1.5rem",
          firstSortType: "desc",
        },
        {
          label: "PÕV",
          field: "palm_oil_free",
          tooltip: "Palmiõlivaba",
          formatFn: this.boolFormat,
          globalSearchDisabled: true,
          width: "1.5rem",
          firstSortType: "desc",
        },
        {
          label: "👍",
          field: "likes",
          type: "number",
          tooltip: "Laike",
          width: "1.5rem",
          firstSortType: "desc",
        },
        {
          label: "💬",
          field: "comments",
          type: "number",
          tooltip: "Kommentaare",
          width: "1.5rem",
          firstSortType: "desc",
        },
        // {
        //   label: "Pilt",
        //   field: "image_url",
        //   globalSearchDisabled: true,
        //   sortable: false,
        // },
        {
          label: "Postitus",
          field: "shortcode",
          globalSearchDisabled: true,
          sortable: false,
        },
      ],
    };
  },
  methods: {
    moneyFormat: (value) => {
      if (value === 0) {
        return "-";
      }
      let euros = value / 100;
      new Intl.NumberFormat("et-EE", { style: "currency", currency: "EUR" });
      return new Intl.NumberFormat("et-EE", {
        style: "currency",
        currency: "EUR",
      }).format(euros);
    },
    boolFormat: (value) => {
      return value ? "jah" : "ei";
    },
  },
};
</script>

<style lang="scss" scoped>
#loadingwrapper {
  padding: 2rem 0;
  width: 100vw;
}
#loadingicon {
  font-size: 4rem;
  animation: spin 800ms linear infinite;
  display: absolute;
  display: inline-block;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>